<span>&lcub;<slot />&rcub;</span>

<style>
  span {
    color: #2f6f9f;
  }
</style>
